import Auth from 'aws-amplify';
import { z } from 'zod';

export async function vlFetch<S extends z.ZodTypeAny>(url: string, schema: S): Promise<z.infer<S>> {
  const currentSession = await Auth.currentSession();
  const idToken = currentSession.getIdToken();
  const user_guid = idToken.payload?.sub;

  if (!user_guid) throw new Error('User GUID not found in ID token');

  if (!window.config) throw new Error('Cannot call until configuration record is loaded');

  const { API_URL } = window.config;

  const cleanUrl = url.replace('APPUSER', user_guid).replace(/^\//, '');
  const baseUrl = API_URL.endsWith('/') ? API_URL : `${API_URL}/`;

  const request = new Request(`${baseUrl}${cleanUrl}`);
  request.headers.set('Authorization', `Bearer ${idToken.getJwtToken()}`);

  const r = await fetch(request);

  if (!r.ok) throw new Error(`Error fetching ${request.url}: ${r.statusText}`);

  if (r.status === 204) return [];

  return schema.parse(await r.json());
}
